module.exports = __webpack_public_path__ + "static/media/SVID_S_7.4ae30ba1.png";